module.exports = {
    sortByVersion: function (array, direction) {
        var self = this;
        // http://stackoverflow.com/questions/6832596/how-to-compare-software-version-number-using-js-only-number
        if (direction) {
            return array.sort(function (a, b) {
                var v1 = a.version || a.firmware_version;
                var v2 = b.version || b.firmware_version;
                return self.versionCompare(v1, v2);
            }).reverse();
        } else {
            return array.sort(function (a, b) {
                var v1 = a.version || a.firmware_version;
                var v2 = b.version || b.firmware_version;
                return self.versionCompare(v1, v2);
            });
        }
    },
    versionCompare: function (v1, v2) {
        var v1parts = v1.split('.');
        var v2parts = v2.split('.');

        function isValidPart(x) {
            return /^\d+$/.test(x);
        }

        if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
            return NaN;
        }

        for (var i = 0; i < v1parts.length; ++i) {
            if (v2parts.length === i) {
                return 1;
            }

            if (v1parts[i] === v2parts[i]) {
                continue;
            } else if (v1parts[i] > v2parts[i]) {
                return 1;
            } else {
                return -1;
            }
        }

        if (v1parts.length !== v2parts.length) {
            return -1;
        }

        return 0;
    },
}